/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();

export type CredentialType = 'licence';

export default (credentialType: CredentialType) => {
  switch (credentialType) {
    case 'licence':
      const ahpraLicence = {
        result: 'Pharmacist',
      };

      const driversLicence = {
        result: 'Verified Valid Drivers Licence',
      };

      return chance.bool() ? ahpraLicence : driversLicence;
  }
};
